import { useEffect, useRef, useMemo } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

import { IError, useNotification } from '#hook/use-notification';

import i18n from '#locale';

export interface IErrorBalance {
    data: {
        error: string,
        httpStatus: number
    },
    status: string
}

export const useHandleRequestError = (errors: Array<FetchBaseQueryError | SerializedError | undefined>) => {
    const { methods } = useNotification();
    const processedErrors = useRef<Set<string>>(new Set());
    const filteredErrors = useMemo(() => errors.filter((error) => !!error) as Array<IError | IErrorBalance>, [errors]);

    useEffect(() => {
        const newErrors = filteredErrors.filter((error) => {
            try {
                // Создаем уникальный ключ для ошибки
                const errorKey = error?.data
                    ? JSON.stringify(error.data)
                    : JSON.stringify(error);

                // Пропускаем уже обработанные ошибки
                if(processedErrors.current.has(errorKey)) {
                    return false;
                }

                // Добавляем в обработанные
                processedErrors.current.add(errorKey);

                return true;
            } catch(e) {
                return false;
            }
        });

        // Показываем только новые ошибки
        newErrors.forEach((error) => {
            const message = (error as IErrorBalance)?.data?.error
                || (error as IError)?.data
                || i18n.t('error-boundary.title');

            methods.error(message);
        });
    }, [filteredErrors, methods]);
};
